import { Box } from "@mui/material";
import React, { ReactNode } from "react";
import { Token } from "../theme";

interface OpsPanelProps {
  title?: string;
  icon?: string;
  svg?: string; // to adapt mui icons size
  actionsRequired?: boolean;
  panelMenu?: ReactNode;
  topBannerLabel?: string;
  topBannerRightLabel?: string;
  children: ReactNode;
  style?: React.CSSProperties;
  fillHeight?: boolean;
  flushBody?: boolean;
}

const OpsPanel: React.FC<OpsPanelProps> = ({
  title,
  icon,
  svg,
  panelMenu,
  topBannerLabel,
  topBannerRightLabel,
  children,
  style,
  fillHeight = false,
  flushBody = false,
}) => {
  return (
    <Box
      style={{
        width: "100%",
        border: `1px solid ${Token.borderDefault}`,
        borderRadius: 8,
        overflow: "hidden",
        backgroundColor: Token.surfaceCard,
        display: "flex",
        flexDirection: "column",
        ...(fillHeight && { height: "100%" }),
        ...style,
      }}
    >
      {!!topBannerLabel && (
        <Box
          style={{
            padding: "12px 12px",
            minHeight: 28,
            backgroundColor: Token.statusDangerBg,
            color: Token.statusDangerFg,
            fontSize: 11.5,
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <span>{topBannerLabel}</span>
          {!!topBannerRightLabel && <span style={{ fontWeight: 500 }}>{topBannerRightLabel}</span>}
        </Box>
      )}

      {!!title && (
        <Box
          style={{
            height: 46,
            flexShrink: 0,
            padding: "0 12px",
            borderBottom: `1px solid ${Token.borderSubtle}`,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 8,
          }}
        >
          <Box display="flex" alignItems="center" style={{ gap: 8, minWidth: 0 }}>
            {icon && <img src={icon} style={{ width: 16, height: 16 }} alt="" />}
            {svg && <img src={svg} style={{ width: 16, height: 16 }} alt="" />}
            <span
              style={{
                fontSize: 13,
                fontWeight: 600,
                color: Token.textPrimary,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {title}
            </span>
          </Box>
          {panelMenu}
        </Box>
      )}

      <Box style={{ padding: flushBody ? 0 : 12, flex: 1, minHeight: 0 }}>{children}</Box>
    </Box>
  );
};

export default OpsPanel;
